import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LayerFigure from './layer-figure';
import { fetchLayerData } from '@actions/layers-actions';

class Layers extends Component {
  UNSAFE_componentWillMount() {
    const { layers, map, name } = this.props;
    if (!layers[name].list.length && map.viewport.bounds) {
      this.props.fetchLayerData(name);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { layers, map, name } = this.props;
    const { next } = nextProps;
    if (!layers[name].loadingComplete && next && this.props.next !== next && map.viewport.bounds) {
      this.props.fetchLayerData(name);
    }
  }

  render() {
    const { list, name } = this.props;
    return list.map(layer => <LayerFigure key={layer.id} layer={layer} name={name} />);
  }
}

Layers.propTypes = {
  fetchLayerData: PropTypes.func,
  id: PropTypes.number,
  layers: PropTypes.object,
  list: PropTypes.array,
  map: PropTypes.object,
  name: PropTypes.string,
  next: PropTypes.string
};

const mapStateToProps = state => {
  const { layers, map } = state;
  return { layers, map };
};

export default connect(mapStateToProps, { fetchLayerData })(Layers);
